<template>
  <span class="purchase-price-breakdown" :class="{ 'purchase-price-breakdown--summary': summary, 'purchase-price-breakdown--right': align === 'right', 'purchase-price-breakdown--compact': summary && compact && value.totals.length === 1 && value.complete }">
    <small v-if="label" class="purchase-price-breakdown__label">{{ label }}</small>
    <span v-for="(bucket, index) in value.totals" :key="bucket.currency || index" class="purchase-price-breakdown__currency">
      <template v-if="summary">
        <strong>{{ value.complete ? money(bucket.total, bucket.currency) : '—' }}</strong>
        <small v-if="showDetails && value.hasDeposit" class="purchase-price-breakdown__details">
          {{ $t('purchase_amounts.products') }} {{ money(bucket.merchandise, bucket.currency) }} ·
          {{ $t('purchase_amounts.deposit') }} {{ money(bucket.deposit, bucket.currency) }}
        </small>
      </template>
      <template v-else>
        <strong v-if="showProduct && isProductBucket(bucket)">{{ breakdown || (price && price.amount != null) ? money(bucket.merchandise, bucket.currency) : '—' }}</strong>
        <small v-if="value.hasDeposit && bucket.deposit !== 0" class="purchase-price-breakdown__deposit" :title="depositTooltip">
          + {{ money(bucket.deposit, bucket.currency) }} {{ $t('purchase_amounts.deposit') }}
        </small>
      </template>
    </span>
    <small v-if="!value.complete" class="text-warning">{{ $t('purchase_amounts.incomplete') }}</small>
  </span>
</template>

<script>
import { purchasePriceBreakdown } from '@/helper/purchasePriceBreakdown';
export default {
  name: 'PurchasePriceBreakdown',
  props: {
    price: { type: Object, default: null }, estimate: { type: Object, default: null },
    quantity: { type: [Number, String], default: 1 }, breakdown: { type: Object, default: null },
    summary: { type: Boolean, default: false }, label: { type: String, default: '' },
    showProduct: { type: Boolean, default: true },
    showDetails: { type: Boolean, default: true },
    compact: { type: Boolean, default: false },
    align: { type: String, default: 'left', validator: value => ['left', 'right'].includes(value) },
  },
  computed: {
    value() { return this.breakdown || purchasePriceBreakdown(this.price, this.estimate, this.quantity); },
    depositTooltip() {
      return (this.estimate?.components || []).filter(component => component.name).map(component => {
        const description = `${component.name} × ${component.quantity_per_unit}`;
        return component.rate?.amount != null && component.rate?.currency
          ? `${description} · ${this.money(component.rate.amount, component.rate.currency)}` : description;
      }).join('\n');
    },
  },
  methods: {
    isProductBucket(bucket) {
      return this.breakdown
        ? bucket.merchandise !== 0 || bucket.currency === this.value.totals[0].currency
        : !this.price || bucket.currency === this.price.currency;
    },
    money(amount, currency) { return currency ? this.$options.filters.toCurrency(amount, currency) : '—'; },
  },
};
</script>

<style scoped>
.purchase-price-breakdown { display: inline-flex; align-items: baseline; flex-wrap: wrap; gap: 0.2rem 0.35rem; font-variant-numeric: tabular-nums; max-width: 100%; min-width: 0; white-space: normal; }
.purchase-price-breakdown__currency { display: inline-flex; align-items: baseline; flex-wrap: wrap; gap: 0.2rem 0.35rem; }
.purchase-price-breakdown__label, .purchase-price-breakdown__details { color: #768192; font-weight: normal; }
.purchase-price-breakdown__deposit { color: #248447; font-weight: 600; }
.purchase-price-breakdown--summary { flex-direction: column; align-items: flex-start; }
.purchase-price-breakdown--summary .purchase-price-breakdown__currency { flex-direction: column; align-items: flex-start; }
.purchase-price-breakdown__details { font-size: 0.75rem; }
.purchase-price-breakdown--right:not(.purchase-price-breakdown--summary),
.purchase-price-breakdown--right:not(.purchase-price-breakdown--summary) .purchase-price-breakdown__currency { justify-content: flex-end; text-align: right; }
.purchase-price-breakdown--summary.purchase-price-breakdown--right { align-items: flex-end; text-align: right; }
.purchase-price-breakdown--summary.purchase-price-breakdown--right .purchase-price-breakdown__currency { align-items: flex-end; }
.purchase-price-breakdown--summary.purchase-price-breakdown--compact { display: inline-grid; grid-template-columns: auto auto; align-items: baseline; gap: 0.15rem 0.35rem; }
.purchase-price-breakdown--compact .purchase-price-breakdown__currency { display: contents; }
.purchase-price-breakdown--compact .purchase-price-breakdown__label { grid-row: 1; grid-column: 1; white-space: nowrap; }
.purchase-price-breakdown--compact strong { grid-row: 1; grid-column: 2; white-space: nowrap; }
.purchase-price-breakdown--compact .purchase-price-breakdown__details { grid-row: 2; grid-column: 1 / -1; white-space: nowrap; font-size: 0.68rem; }
.purchase-price-breakdown--compact.purchase-price-breakdown--right { justify-items: end; }
</style>
